module.exports = __webpack_public_path__ + "static/img/guangdian.c4f1943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdian.png
// module id = 84kK
// module chunks = 19